import React, { useContext, useState, useEffect } from "react";
import CustomSelect from "../../UI Component/CustomSelect/CustomSelect";
import StaffHeader from "../CommonComponents/StaffHeader";
import StaffSettingsOptions from "./StaffSettingsOptions";
import "./style.scss";
import SelectDoctorImg from "../../../assets/HealthProgession.svg";
import StaffContext from "../StaffContext";
import Loader from "../../UI Component/Loader/Loader";
import PageHeading from "../CommonComponents/PageHeader/page-header";
import DownloadReport from "../../DownloadReport/DownloadReport";
import DoctorContext from "../../ClinicComponents/ClinicWrapper/DoctorContext";

const StaffSettings = () => {
  const doctorSelected = false;
  const [pageLoader, setPageLoader] = useState(false);
  const staff_context = useContext(DoctorContext);
  const [doctorList, setdoctorList] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState({});

  useEffect(() => {
    setdoctorList(staff_context.selectedDoctor);
  }, [staff_context.selectedDoctor]);

  useEffect(() => {
    if (localStorage.getItem("staff_selected_dr") !== undefined) {
      let selectedOption = JSON.parse(
        localStorage.getItem("staff_selected_dr")
      );
      let arr = [];
      staff_context.selectedDoctor.map((data, inx) => {
        arr.push(data.id);
      });
      if (
        selectedOption?.doctor_id &&
        arr.includes(selectedOption?.doctor_id)
      ) {
        setSelectedDoctor(selectedOption);
      }
    } else {
      setSelectedDoctor({});
    }
  }, [localStorage.getItem("staff_selected_dr"), staff_context.selectedDoctor]);

  const handleOnChange = (option) => {
    localStorage.setItem("staff_selected_dr", JSON.stringify(option));
    setSelectedDoctor(option);
  };

  return (
    <>
      {pageLoader ? (
        <Loader />
      ) : (
        <div className="staff-settings-container">
          {/* <PageHeading text={"SETTINGS"} /> */}
          <div className="settings-header">
            <StaffHeader isPageHeading={true} headerText={"Settings"} />
          </div>
          <div className="settings-select">
            <div className="row">
              <div className="col-sm-12 col-lg-5 col-12  d-flex">
                <label className="d-flex align-items-center mb-0 mr-3">
                  Doctor
                </label>
                <CustomSelect
                  className="select_dropdownOptions"
                  showSearch={true}
                  placeholder={"Select Doctor"}
                  options={doctorList}
                  //   value={myScheduleFeesContext.selectedConsultationType}
                  value={selectedDoctor}
                  handleChange={handleOnChange}
                  showSearch={true}
                  isSearchable={false}
                  seacrhbarPlaceholder={"Search for Doctor"}
                />
              </div>
            </div>
          </div>
          <div className="settings-content">
            {selectedDoctor?.id ? (
              <StaffSettingsOptions staffDoctor={selectedDoctor} />
            ) : (
              <div className="no-data-container">
                <div>
                  <div className="no-data-icon">
                    <img src={SelectDoctorImg} alt="" />
                  </div>
                  <p className="no-data-heading">Select A Doctor</p>
                  <p className="no-data-text">
                    Please select a doctor to view their records
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      <DownloadReport />
    </>
  );
};

export default StaffSettings;
